import React, { useEffect } from 'react'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4geodata_peruHigh from '@amcharts/amcharts4-geodata/peruHigh'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)

function Map({ data, showList }) {
  useEffect(() => {
    // Map instance
    let map = am4core.create('chartdiv', am4maps.MapChart)
    map.geodata = am4geodata_peruHigh
    map.chartContainer.wheelable = false
    map.seriesContainer.draggable = false
    map.seriesContainer.resizable = false
    map.maxZoomLevel = 1

    // Set projection
    map.projection = new am4maps.projections.Miller()

    // Map polygon series
    let polygonSeries = new am4maps.MapPolygonSeries()

    polygonSeries.useGeodata = true
    map.series.push(polygonSeries)

    // Configure series
    let polygonTemplate = polygonSeries.mapPolygons.template
    polygonTemplate.tooltipText = '{name}: {value} candidatos'
    polygonTemplate.fontSize = 12
    polygonTemplate.fill = am4core.color('#e2e2e2')

    // Create hover state and set alternative fill color
    let hs = polygonTemplate.states.create('hover')
    hs.properties.fill = am4core.color('#4c4c4c')

    // Add Zoom Control
    //map.zoomControl = new am4maps.ZoomControl()

    // Add heat rule
    polygonSeries.heatRules.push({
      property: 'fill',
      target: polygonSeries.mapPolygons.template,
      min: am4core.color('#9eddde'),
      max: am4core.color('#039598'),
      minValue: 0,
      maxValue: 50
    })

    // Add heat legend
    var heatLegend = map.createChild(am4maps.HeatLegend)
    heatLegend.series = polygonSeries
    heatLegend.width = am4core.percent(50)
    heatLegend.align = 'left'
    heatLegend.marginLeft = 20
    heatLegend.marginBottom = 20
    heatLegend.fontSize = 11
    heatLegend.valign = 'bottom'
    heatLegend.minValue = 0
    heatLegend.maxValue = 50

    polygonSeries.data = data

    polygonTemplate.events.on(
      'hit',
      function(ev) {
        // zoom to an object
        showList(ev.target.dataItem.dataContext.id)
        //ev.target.series.chart.zoomToMapObject(ev.target)
        /*polygonSeries.data = [
        {
          id: ev.target.dataItem.dataContext.id,
          fill: am4core.color('#00a8ac')
        }
      ]*/
        // Bind "fill" property to "fill" key in data
        polygonTemplate.propertyFields.fill = 'fill'

        // get object info
        //console.log(ev.target.dataItem.dataContext)
      },
      this
    )
  }, [data])

  return <div id="chartdiv" style={{ width: '100%', height: '500px' }}></div>
}

export default Map
